import { CANVAS_BASE_SIZE } from '@glueapp/graph-types';

export const DRAW_CONFIG = {
    BASE_SIZE: CANVAS_BASE_SIZE,
    SUB_GRAPH_NODE_WIDTH_MINIMUM: 800,
    SUB_GRAPH_NODE_HEIGHT_MINIMUM: 300,
    DEFAULT_MAX_DISPLAYED_OUTPORTS: 7,
};
